//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is the property of 6over6 Ltd. and its licensors. Any use of the Software is strictly prohibited unless an explicit license or permission is granted by 6over6 Ltd.
export default {
  namespaced: true,
  state: {
    hasZoomed: false,
    goWidth: null,
    goHeight: null,
    winWidth: null,
    winHeight: null,
    ratioWidth: null,
    ratioHeight: null,
    hasScreenCalibrated: false,
    canMarkersTargetsFit: true,
  },
  actions: {
    setHasScreenCalibrated({ state }, value) {
      state.hasScreenCalibrated = value;
      if (value) {
        // initial calibration
        const go = document.getElementById("glasseson_wc-app");
        state.goWidth = go.clientWidth;
        state.goHeight = go.clientHeight;
        state.winWidth = window.outerWidth;
        state.winHeight = window.outerHeight;
        state.ratioWidth = state.goWidth / state.winWidth;
        state.ratioHeight = state.goHeight / state.winHeight;
      }
    },
    checkResolution({ state }) {
      if (!state.hasScreenCalibrated) {
        return;
      }
      const windowWidth = window.outerWidth;
      const windowHeight = window.outerHeight;

      const go = document.getElementById("glasseson_wc-app");
      const goWidth = go.clientWidth;
      const goHeight = go.clientHeight;

      // if either outerWidth or outerHeight changed, we consider it a resize, not zoom
      if (windowWidth !== state.winWidth || windowHeight !== state.winHeight) {
        state.goWidth = state.goWidth * (windowWidth / state.winWidth);
        state.goHeight = state.goHeight * (windowHeight / state.winHeight);
        state.winWidth = windowWidth;
        state.winHeight = windowHeight;
        return;
      }

      // Check if current ratios are close to initial ratios
      // Use a small tolerance for floating point comparison
      const TOLERANCE = 0.01;
      const ratioWidth = goWidth / windowWidth;
      const widthDiff = Math.abs(ratioWidth - state.ratioWidth) > TOLERANCE;
      const ratioHeight = goHeight / windowHeight;
      const heightDiff = Math.abs(ratioHeight - state.ratioHeight) > TOLERANCE;
      state.hasZoomed = widthDiff > TOLERANCE && heightDiff > TOLERANCE;
    },
  },
};
